export const initState = {
    version: "0.0.7",
    applicationState: {
        logoUrl: document.getElementById("applicationLogoUrl").value !== "" &&
            document.getElementById("applicationLogoUrl").value !== null &&
            document.getElementById("applicationLogoUrl").value !== undefined ?
            document.getElementById("applicationLogoUrl").value :
            process.env.REACT_APP_LOGO_URL,
        apiUrl: document.getElementById("applicationApiUrl").value || process.env.REACT_APP_RPA_URL
    },
    user: {
        verified: false,
        sessionTTL: 8,
        verifiedTime: null,
        viewMode: "card",
        showCardDetails: false,
        sortBy: "rpaName",
        sortDir: "asc"
    }
};
